import constants from '../constants';

const isPageCreationAvailable = (sitePageTemplates) =>
  !!sitePageTemplates &&
  !!sitePageTemplates.length &&
  sitePageTemplates.some((template) => template.id === constants.BLANK_PAGE_TEMPLATE_ID);

export default isPageCreationAvailable;
